<section class="masonry" (window:resize)="onResize($event)">
  <div class="masonry-item" *ngFor="let item of items, index as i">
    <div class="masonry-content">
      <picture class="image-container">
        <img [src]="item.images ? item.images[0] : 'https://via.placeholder.com/1600x2000'"
             [alt]="item.name"
             class="masonry-image"
             loading="eager"
             decoding="sync" />
      </picture>
      <h2 class="name">{{item.name}}</h2>
      <p class="description">{{item.description}}</p>
      <div *ngIf="item.tags" class="tags">
        <mat-chip-set role="list">
          <mat-chip *ngFor="let tag of item.tags" role="listitem">{{tag}}</mat-chip>
        </mat-chip-set>
      </div>

      <div class="links">
        <a mat-icon-button *ngIf="item.link" matTooltip="View preview" [href]="item.link" target="_blank">
          <mat-icon fontIcon="preview"></mat-icon>
        </a>

        <a mat-icon-button *ngIf="item.github" matTooltip="View code" [href]="item.github" target="_blank">
          <mat-icon svgIcon="github"></mat-icon>
        </a>
      </div>
    </div>
  </div>
</section>
